(function($, _, Highcharts) {
  var ns = window.nspace("ccc.viz.map.views");

  // Clever way to tell if we are sorting by a number.
  // From here: http://stackoverflow.com/questions/18082/validate-numbers-in-javascript-isnumeric/1830844#1830844
  function isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  /**
   * Displays the "region summary" view on the right hand side of the map that
   * shows which location is selected, it's rank, and a trend chart.
   */
  ns.SelectedRegionSummaryView = Backbone.View.extend({
    el: "#selected-region-summary-container",
    templateSelector: "#selected-region-summary-template",
    name: "SelectedRegionSummaryView",
    sparklineContainerId: "chart-container",

    initialize: function(options) {
      this.initialRenderPromise = $.Deferred();
      this.chartAnimationComplete = $.Deferred();

      _.bindAll(
        this,
        "render",
        "initialRender",
        "loadTemplate",
        "getCurrentFips",
      );

      this.dataResponseModel = options.dataResponseModel;

      this.model.on("change", _.debounce(this.render, 200));
    },

    getInitialRenderPromise: function() {
      return this.initialRenderPromise;
    },

    loadTemplate: function() {
      // Get the underscore template
      if (!this.template) {
        var $tmpl = $(this.templateSelector);
        if ($tmpl.length === 0) {
          throw "Could not find the " +
            this.name +
            " template: " +
            this.templateSelector;
        }

        // Pre-compile and cache the template
        this.template = _.template($tmpl.html());
      }
    },

    initialRender: function() {
      this.loadTemplate();

      var html = this.template({
        sparklineContainerId: this.sparklineContainerId,
      });
      this.$el.html(html);

      // Save off references to the portions of the DOM that will
      // be updated as data changes
      this.$name = $("[data-name]", this.el);
      this.$dataSummary = $("[data-summary]", this.el);
      this.$rank = $("[data-rank] .rank", this.el);
      this.$rankSubtext = $("[data-rank] .subtext", this.el);
      this.$trendContainer = $(".legend-chart", this.el);
    },

    renderChart: function(xAxisCategories, dataSeries, displayValues) {
      var self = this;

      if (dataSeries.length > 1) {
        $("#" + self.sparklineContainerId).show();

        ccc.viz.map.util.ChartRenderer.renderSparkline(
          self.sparklineContainerId,
          xAxisCategories,
          dataSeries,
          displayValues,
          function() {
            self.chartAnimationComplete.resolve();
          },
        );
      }
      else {
        $("#" + self.sparklineContainerId).hide();

        // Resolve the animation promise, since we don't have to wait for an animation to complete
        self.chartAnimationComplete.resolve();
      }
    },

    updateChart: function(data, timeFramesById) {
      var xAxis = [];
      var dataSeries = [];
      var displayValues = {};

      // Assemble the updated data series
      _.each(data, function(dataInfo) {
        var tfName = timeFramesById[dataInfo.timeFrameId].name;
        xAxis.push(tfName);
        if (isNumber(dataInfo.value)) {
          dataSeries.push(parseFloat(dataInfo.value));
        }
        else {
          dataSeries.push(null);
        }
        displayValues[tfName] = dataInfo.displayValue;
      });

      this.$chart = this.renderChart(xAxis, dataSeries, displayValues);
    },

    getCurrentFips: function() {
      return this.model.get("selectedFips");
    },

    /**
     * Renders the summary area
     */
    render: function() {
      var self = this;

      if (!this.isRendered) {
        this.initialRender();
        this.isRendered = true;
      }

      var fips = this.getCurrentFips();

      // If there's no selected fips, hide the current view
      if (!fips || fips === "a") {
        self.$el.hide();
        self.initialRenderPromise.resolve();
        return;
      }

      // Get the data to display
      $.when(this.dataResponseModel.getDataResponse()).done(function() {
        // We have a fips. Ensure we're visible
        if (!self.$el.is(":visible")) {
          self.$el.fadeIn();
        }

        // Extract the data we need
        var response = self.dataResponseModel.get("response");
        if (!response) {
          self.$el.hide();
          return;
        }

        var tfId = self.model.get("timeFrameId");
        var allYearsData = response.dataByFips[fips];
        var data = !allYearsData
          ? null
          : _.find(allYearsData, function(yearData) {
            return yearData.timeFrameId === tfId;
          });

        var location = response.locationsByFips[fips];

        // Defaults
        var displayVals = {
          locationName: "Location",
          rank: "",
          rankSubtext: "",
        };

        // Record items we want to animate
        var fadeables = [];


        // data summary
        // Pull it from the global selector instance.
        var summary = ccc.viz.map.views.instances.SelectorsView.getDataSummaryByPropertyNames(["indicatorId"]);
        if (_.str.isBlank(summary)) {
          summary = response.indicatorGroupName;
        }

        // Actual values
        if (location) {
          displayVals.locationName = location.name;
          fadeables.push(self.$name[0]);
          
          if (location.isUninhabited) {
            summary = "This area is uninhabited";
          }
        }

        if (data) {
          displayVals.rank = _.str.isBlank(data.rank)
            ? data.displayValue
            : "Ranks " + data.rank;
          fadeables.push(self.$rank[0]);

          displayVals.rankSubtext = response.rankSubtext;
          if (_.str.isBlank(displayVals.rankSubtext)) {
            displayVals.rankSubtext =
              "in " + response.timeFramesById[tfId].name;
          }
        }

        // Hook for subclasses to modify display values
        if (self.overrideDisplayValues) {
          self.overrideDisplayValues(displayVals);
        }

        // Update the name
        self.$name.text(displayVals.locationName);

        self.$dataSummary.text(summary);

        // rank
        self.$rank.text(displayVals.rank);

        // rank subtext
        if (_.str.isBlank(displayVals.rankSubtext)) {
          self.$rankSubtext.hide();
        }
        else {
          if (
            self.$rankSubtext.text() !== displayVals.rankSubtext ||
            !self.$rankSubtext.is(":visible")
          ) {
            fadeables.push(self.$rankSubtext[0]);
          }

          self.$rankSubtext.text(displayVals.rankSubtext);
        }
 
        function StringArrayHasDuplicates (array) {
          return (new Set(array)).size !== array.length;
        }

        if (allYearsData) {
        // Trend chart is intended to show data for multiple years, one value per year
        // Validate that there is more than one timeframe to show a trend for
        // and that there are no duplicate timeframes
          var tfIds = allYearsData.map(datum => datum.timeFrameId);        
          if (tfIds.length > 1) {
            if (!StringArrayHasDuplicates(tfIds)) {
              self.updateChart(allYearsData, response.timeFramesById);
            }
            else {
              console.warn("Selected region's trend chart data has duplicate timeframes.");
            }
          }
        }

        // Animate the text fields transitions
        $(fadeables)
          .hide()
          .fadeIn(function() {
            // Also ensure the chart animation is complete before resolving our initial render promise
            $.when(self.chartAnimationComplete).done(function() {
              self.initialRenderPromise.resolve();
            });
          });
      });
    },
  });
})(jQuery, _, Highcharts);
